import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface IconCircleProps {
  children: ReactNode;
  size?: keyof typeof sizeMap;
  variant?: "primary" | "success" | "warning" | "info";
  sx?: SxProps<Theme>;
}

const sizeMap = {
  tiny: { width: "30px", height: "30px", fontSize: "16px" },
  small: { width: "50px", height: "50px", fontSize: "20px" },
  medium: { width: "60px", height: "60px", fontSize: "24px" },
  large: { width: "80px", height: "80px", fontSize: "32px" },
};

const variantMap = {
  primary: {
    background: "linear-gradient(135deg, #007bff, #0056b3)",
    boxShadow: "0 8px 20px rgba(0,123,255,0.3)",
  },
  success: {
    background: "linear-gradient(135deg, #28a745, #20c997)",
    boxShadow: "0 8px 20px rgba(40,167,69,0.3)",
  },
  warning: {
    background: "linear-gradient(135deg, #ffc107, #e0a800)",
    boxShadow: "0 8px 20px rgba(255,193,7,0.3)",
  },
  info: {
    background: "linear-gradient(135deg, #17a2b8, #138496)",
    boxShadow: "0 8px 20px rgba(23,162,184,0.3)",
  },
};

export const IconCircle = ({ children, size = "medium", variant = "primary", sx }: IconCircleProps) => {
  return (
    <Box
      sx={{
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0",
        color: "white",
        "& svg": {
          fontSize: "1em",
        },
        ...sizeMap[size],
        ...variantMap[variant],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
